import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import stickySidebar from 'sticky-sidebar';
import { DataMaterialsService } from '@components/materials/data-materials.service';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var GlobalMaterialsComponent = /** @class */ (function () {
    function GlobalMaterialsComponent(globalDataService, requestV2Service, dataMaterialsService, router) {
        this.globalDataService = globalDataService;
        this.requestV2Service = requestV2Service;
        this.dataMaterialsService = dataMaterialsService;
        this.router = router;
        this.isLoaded = false;
        this.activeRoute = 'listing';
        this.getScreenSize();
    }
    GlobalMaterialsComponent.prototype.getScreenSize = function () {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    };
    GlobalMaterialsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.routeObs$ = this.router.events.subscribe(function (val) {
                            var routes = ['listing', 'version', 'alternative'];
                            _this.activeRoute = routes.find(function (r) {
                                if (val.url) {
                                    return val.url.includes(r);
                                }
                                return null;
                            });
                        });
                        return [4 /*yield*/, this.initProjectAndMaterials()];
                    case 1:
                        _a.sent();
                        if (this.screenWidth > 767) {
                            this.createStickyBar();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GlobalMaterialsComponent.prototype.initProjectAndMaterials = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var globalLoader;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                globalLoader = document.getElementById('circle-container');
                if (globalLoader) {
                    globalLoader.style.display = 'none';
                }
                this.dataMaterialsService.refreshData = true;
                this.projectSubscription = this.globalDataService
                    .getCurrentProject()
                    .subscribe(function (project) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!project || !this.dataMaterialsService.refreshData) {
                                    return [2 /*return*/];
                                }
                                // Set Projects
                                this.currentProject = project;
                                this.dataMaterialsService.currentProject = project;
                                this.dataMaterialsService.refreshData = false;
                                return [4 /*yield*/, this.dataMaterialsService.computeQuotationMaterialsData()];
                            case 1:
                                _a.sent();
                                this.isLoaded = true;
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    GlobalMaterialsComponent.prototype.ngOnDestroy = function () {
        if (this.routeObs$) {
            this.routeObs$.unsubscribe();
        }
    };
    GlobalMaterialsComponent.prototype.createStickyBar = function () {
        new stickySidebar('#sidebar', {
            topSpacing: 0,
            bottomSpacing: 20,
            resizeSensor: true,
            containerSelector: '.global-material-root',
            stickyClass: 'is-affixed',
            innerWrapperSelector: '.container-navbar'
        });
    };
    return GlobalMaterialsComponent;
}());
export { GlobalMaterialsComponent };
